import { render } from "./BatchStreamLogList.vue?vue&type=template&id=45ff3c06&scoped=true&ts=true"
import script from "./BatchStreamLogList.vue?vue&type=script&lang=ts"
export * from "./BatchStreamLogList.vue?vue&type=script&lang=ts"

import "./BatchStreamLogList.vue?vue&type=style&index=0&id=45ff3c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ff3c06"]])

export default __exports__